import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {DelegationListComponent} from './delegation-list/delegation-list.component';

@NgModule({
  imports: [RouterModule.forChild([
    {
      path: 'delegation',
      children: [
        {
          path: '',
          component: DelegationListComponent
        }
      ]
    }
  ])],
  exports: [RouterModule],
  declarations: []
})
export class DelegationRouting {

}



// WEBPACK FOOTER //
// ./src/app/modules/delegation/delegation.routing.ts